<template>
  <div>
    <div class="head">
      <el-form :inline="true" :model="selectForm" ref="orderReceipt" class="demo-form-inline" size="mini">
        <el-form-item>
          <el-date-picker
            v-model="selectForm.dateTime"
            type="date"
            :picker-options="pickerDate"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp"
            @change="changeDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select multiple collapse-tags v-model="selectForm.categoryId" clearable style="width: 150px;margin-right: 5px"  placeholder="栏目(默认全部)">
            <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
      </el-form>
    </div>
    <div class="echarts" :style="{height: windowHeight + 'px'} ">
      <chart theme="macarons" :options="polar" ref="echar" :init-options="initOptions" :auto-resize="true" @timelinechanged="timelinechanged"/>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import theme from '../../../ECharts/macarons.json'
import 'echarts/theme/dark'
import { financeByUser } from '../../../api/ordersStatistics'
import { getAppInfo } from '../../../api/app'

ECharts.registerTheme('macarons', theme)
export default {
  components: {
    chart: ECharts
  },
  data: function () {
    return {
      selectForm: {
        appId: '',
        categoryId: [],
        dateType: '2',
        dateTime: new Date().getTime()
      },
      appInfo: {},
      findDate: [],
      pickerDate: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '上月',
          onClick (picker) {
            picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 31)
          }
        }, {
          text: '去年',
          onClick (picker) {
            picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 366)
          }
        }]
      },
      windowHeight: '',
      initOptions: {},
      initDate: '',
      timeline: {
        scope: [],
        xLine: [],
        data: {}
      },
      timeLineIndex: '',
      polar: {
        baseOption: {
          timeline: {
            axisType: 'category',
            orient: 'vertical',
            left: null,
            right: 40,
            top: 20,
            bottom: 2,
            width: 55,
            height: null,
            // realtime: false,
            loop: true,
            autoPlay: false,
            // currentIndex: this.timeline.scope.length - 1,
            playInterval: 1000,
            inverse: true,
            // data: this.timeline.scope,
            label: {
              position: 20,
              formatter: function (value, index) {
                return new Date(value).format('yyyy年M') + '月'
              }
            }
          },
          title: {
            subtext: '',
            textStyle: {
              align: 'center'
            }
          },
          tooltip: {},
          legend: {
          },
          toolbox: {
            show: true,
            feature: {
              magicType: {type: ['line', 'bar']},
              saveAsImage: {show: true}
            },
            right: '100'
          },
          calculable: true,
          grid: {
            top: 80,
            bottom: 50,
            left: 50,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  type: 'dashed'
                }
              }
            }
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              interval: 0,
              formatter: function (value, index) {
                if (index % 2 === 0) {
                  return new Date(value).format('M-d')
                }
                return new Date(value).format('\nM-d')
              }
            },
            splitLine: {show: false}
          },
          yAxis: [
            {
              type: 'value',
              name: '销售（元）'
            }
          ]
        },
        options: []
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.windowHeight = document.documentElement.offsetHeight - 270
      this.$refs.echar.showLoading()
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.selectForm.appId = to.params.id
      getAppInfo(to.params.id).then((response) => {
        vm.appInfo = response.data.data
        financeByUser(vm.selectForm).then((response) => {
          vm.initDate = response.data.data
          vm.init(response.data.data)
        })
      })
    })
  },
  methods: {
    search () {
      this.$refs.echar.showLoading()
      let _this = this
      financeByUser(this.selectForm).then((response) => {
        console.log(response.data.data)
        _this.initDate = response.data.data
        _this.init(response.data.data)
      })
    },
    changeDate () {
    },
    init (financeData) {
      console.log(financeData)
      this.polar.options = []
      let _this = this
      let timeline = this.wei.getMonth(this.selectForm.dateTime)
      let timeLineIndex = new Date(this.selectForm.dateTime).getMonth()
      this.timeLineIndex = new Date(this.selectForm.dateTime).getMonth()
      this.$nextTick(() => {
        this.timeline.scope = timeline
        this.polar.baseOption.legend.data = financeData.map(function (item) {
          return item.name
        })
        for (let x = 0; x < timeline.length; x++) {
          this.timeline.xLine[x] = this.wei.getDate(timeline[x])
          this.polar.options.push({
            title: {text: new Date(timeline[x]).format('yyyy年M月')},
            series:
              (function () {
                const pi = []
                const series = []
                for (let s = 0; s < financeData.length; s++) {
                  let financeDate
                  if (x === new Date(_this.selectForm.dateTime).getMonth()) {
                    financeDate = _this.wei.createMonth(financeData[s].data, timeline[x])
                  } else {
                    financeDate = _this.wei.createMonth([], timeline[x])
                  }
                  financeDate.name = financeData[s].name
                  pi.push(financeDate)
                  var dataList = {
                    data: financeDate.daysOfMonth.map(function (item) {
                      return {
                        name: item.date,
                        value: item.moneySum * 1,
                        label: {
                          normal: {
                            show: true
                          }
                        }
                      }
                    })
                  }
                  series.push(dataList)
                }
                var piData = {}
                piData.data = pi.map(function (item) {
                  return {
                    name: item.name,
                    value: item.sum
                  }
                })
                series.push(piData)
                return series
              }())
          })
        }
        this.polar.baseOption.timeline.currentIndex = timeLineIndex
        this.polar.baseOption.timeline.data = this.timeline.scope
        this.polar.baseOption.xAxis.data = this.timeline.xLine[timeLineIndex]
        this.polar.baseOption.series = (function () {
          var serie = []
          for (var i = 0; i < financeData.length; i++) {
            var item = {
              name: financeData[i].name,
              type: 'line',
              areaStyle: {
                opacity: 0.2
              },
              markLine: {
                data: [
                  {type: 'average', name: '平均值'}
                ]
              }
            }
            serie.push(item)
          }
          var pies = {
            name: '销售占比',
            type: 'pie',
            center: ['75%', '25%'],
            radius: ['10%', '20%'],
            roseType: 'angle',
            tooltip: {
              formatter: '{a} <br/>{b} : {c}元 ({d}%)'
            },
            label: {
              normal: {
                borderRadius: 5,
                padding: 5,
                textBorderColor: '#fff',
                textBorderWidth: 5
              }
            },
            itemStyle: {
              opacity: 0.1,
              normal: {
                shadowBlur: 100,
                shadowColor: 'rgba(0, 0, 0, 0.3)'
              }
            }
          }
          serie.push(pies)
          return serie
        }())
        this.$refs.echar.mergeOptions(this.polar)
        this.$refs.echar.hideLoading()
      })
    },
    timelinechanged (params) {
      this.$refs.echar.showLoading()
      let _this = this
      this.selectForm.dateTime = new Date(this.timeline.scope[params.currentIndex])
      financeByUser(this.selectForm).then((response) => {
        _this.init(response.data.data)
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .head
    width 100%
    padding 10px
    background: #fff
    border-radius: 8px 8px 0 0
    padding-left: 30px
    padding-right: 30px
  .echarts
    width: 100%
    height 100%
    margin: auto
    text-align: center
    background: #fff
</style>
